module.exports = "/fonts/Montserrat-Bold.ttf?ade91f473255991f410f61857696434b";